import useReportsAction from "./useReportsAction";
import {useEffect, useMemo, useState} from "react";
import {getBonusData, getBonusFilters} from "../../helpers/reports";
import useReportsData from "./useReportsData";
import _ from "lodash";

const useBonusReport = () => {
	const {loading, bonusReport} = useReportsData()
	const {getBudgetAndGoalsReport} = useReportsAction()
	useEffect(() => {
		getBudgetAndGoalsReport()
	}, [getBudgetAndGoalsReport])
	const [filters, setFilters] = useState(getBonusFilters(bonusReport))
	useEffect(() => {
		setFilters(getBonusFilters(bonusReport))
	}, [bonusReport])
	
	const data = useMemo(() => (
		getBonusData(bonusReport, filters)
	), [bonusReport, filters])
	
	const bonusType = useMemo(() => (
		bonusReport.length > 0 ? bonusReport[0]?.goalScenario : null
	), [bonusReport])
	
	const handleFilters = (newFilterValue) => {
		const {filter, description, value, uniqueValue} = newFilterValue
		const currentValues = filters[filter].values
		const mappedValues = _.map(currentValues, 'value')
		const mapFalseValues = mappedValues.filter(f => f === false)
		const updateValues = currentValues.map(val => ({
			...val,
			value: val.description === description ? (
				uniqueValue ? (
					value === false ? !value : value
				) : (
					value === false && val.value === true && mapFalseValues.length === mappedValues.length - 1 ? val.value : value
				)
			) : (
				uniqueValue ? (
					value === false && mapFalseValues.length === mappedValues.length - 1 ? val.value : !value
				) : val.value
			)
		}))
		setFilters(prevState => ({
			...prevState,
			[filter]: {
				...prevState[filter],
				values: [...updateValues]
			}
		}))
	}
	
	return {
		loading,
		data,
		filters,
		handleFilters,
		bonusType
	}
}

export default useBonusReport